import { Row, Col } from 'antd';
import { InputDecimal } from '../..';
import FloatingFormItem from '../../FloatingFormItem';
import SectionCard from '../../SectionCard';

interface Props {
  prefixPath?: string[];
}

export default function IbsFormFields({
  prefixPath = ['itemTaxes', 'ibsCbs'],
}: Props) {
  return (
    <>
      <h1>IBS - Imposto sobre Bens e Serviços</h1>

      {/* ===== IBS - UF (UB17..UB35) ===== */}
      <SectionCard
        visible
        style={{ marginBottom: 24 }}
        title="IBS - UF"
        subtitle="Aplica redução para obter alíquota efetiva se não informada explicitamente"
      >
        <Row gutter={[16, 16]}>
          <Col span={24} sm={12} md={6}>
            <FloatingFormItem
              label="Alíquota (%)"
              name={[...prefixPath, 'ibsUfAliquot']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>

          {/* <Col span={24} sm={12} md={6}>
            <FloatingFormItem
              label="Redução de Alíquota (%)"
              name={[...prefixPath, 'ibsUfReductionAliquot']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>

          <Col span={24} sm={12} md={6}>
            <FloatingFormItem
              label="Alíquota Efetiva (%)"
              extra={
                <Popover
                  overlayInnerStyle={{ width: 250 }}
                  content="Se informado, prevalece sobre 'Alíquota UF' - 'Redução de Alíquota UF'"
                >
                  <a>Informação</a>
                </Popover>
              }
              name={[...prefixPath, 'ibsUfEffectiveAliquot']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>

          <Col span={24} sm={12} md={6}>
            <FloatingFormItem
              label="Percentual do Diferimento (%)"
              name={[...prefixPath, 'ibsUfDefermentPercentage']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>

          <Col span={24} sm={12} md={6}>
            <FloatingFormItem
              label="Valor do Diferimento"
              name={[...prefixPath, 'ibsUfDefermentValue']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>

          <Col span={24} sm={12} md={6}>
            <FloatingFormItem
              label="Valor do Tributo Devolvido (cashback)"
              name={[...prefixPath, 'ibsUfTaxReturned']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col> */}

          <Col span={24} sm={12} md={6}>
            <FloatingFormItem
              label="Valor (auto)"
              name={[...prefixPath, 'ibsUfValue']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>
        </Row>
      </SectionCard>

      {/* ===== IBS - Município (UB36..UB54) ===== */}
      <SectionCard visible style={{ marginBottom: 24 }} title="IBS - Município">
        <Row gutter={[16, 16]}>
          <Col span={24} sm={12} md={6}>
            <FloatingFormItem
              label="Alíquota do Município (%)"
              name={[...prefixPath, 'ibsMunicipalAliquot']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>

          {/* <Col span={24} sm={12} md={6}>
            <FloatingFormItem
              label="Alíquota de Redução (%)"
              name={[...prefixPath, 'ibsMunicipalReductionAliquot']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>

          <Col span={24} sm={12} md={6}>
            <FloatingFormItem
              label="Alíquota Efetiva (%)"
              extra={
                <Popover
                  overlayInnerStyle={{ width: 250 }}
                  content="Se informado, prevalece sobre 'Alíquota do Município' - 'Alíquota de Redução do Município'"
                >
                  <a>Informação</a>
                </Popover>
              }
              name={[...prefixPath, 'ibsMunicipalEffectiveAliquot']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>

          <Col span={24} sm={12} md={6}>
            <FloatingFormItem
              label="Percentual do diferimento (%)"
              name={[...prefixPath, 'ibsMunicipalDeferralPercentage']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>

          <Col span={24} sm={12} md={6}>
            <FloatingFormItem
              label="Valor do Diferimento"
              name={[...prefixPath, 'ibsMunicipalDeferralValue']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>

          <Col span={24} sm={12} md={6}>
            <FloatingFormItem
              label="Tributo Devolvido (cashback)"
              name={[...prefixPath, 'ibsMunicipalTaxReturned']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col> */}

          <Col span={24} sm={12} md={6}>
            <FloatingFormItem
              label="Valor (auto)"
              name={[...prefixPath, 'ibsMunicipalValue']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>
        </Row>
      </SectionCard>

      <h2>Totais IBS</h2>

      <Row gutter={[16, 16]}>
        <Col span={24} sm={12} md={6}>
          <FloatingFormItem
            label="Valor Total do IBS (UF + Mun)"
            name={[...prefixPath, 'ibsTotalValue']}
          >
            <InputDecimal />
          </FloatingFormItem>
        </Col>
      </Row>
    </>
  );
}
